<template>
    <template-layout fullheader="true">
        <template slot="header">
            <div class="container">
                <div class="columns">
                    <div class="column"></div>
                    <div class="column">
                        <div class="box">
                            <h1 class="title">Ingresá a tu cuenta</h1>

                            <form class="login-box">
                                <b-field label="Email o usuario" :type="error ? 'is-danger' : ''" :custom-class="error ? 'has-text-danger' : ''">
                                    <b-input v-model="username" name="email" type="text" placeholder=""></b-input>
                                </b-field>

                                <b-field label="Password" :type="error ? 'is-danger' : ''" :custom-class="error ? 'has-text-danger' : ''">
                                    <b-input v-model="password" name="password" type="password" password-reveal placeholder="Your password"></b-input>
                                </b-field>

                                <p v-if="error && errorType === 'authorization.notverified'" class="help is-danger">Para activar tu cuenta revisá el email que te enviamos al registrarte.</p>
                                <p v-else-if="error" class="help is-danger">Revisá los datos ingresados</p>

                                <button class="button is-primary" :class="{ 'is-loading': isLoading }" v-on:click.prevent="onLogin">Login</button>
                            </form>

                            <div class="has-text-centered" style="margin-top: 20px;">
                                <p><router-link class="" :to="{ name: 'ForgotPassword' }">No recuerdo mi contraseña</router-link></p>
                                <p><router-link class="" :to="{ name: 'Register' }">No tengo cuenta</router-link></p>
                            </div>
                        </div>
                    </div>
                    <div class="column"></div>
                </div>
            </div>
        </template>

        <template slot="content">

        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../../layout/TemplateLayout.vue';

    export default {
        name: 'login',

        data() {
            return {
                isLoading: false,

                error: false,
                errorType: '',

                username: '',
                password: ''
            }
        },

        components: {
            TemplateLayout
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                const isLoggedIn = vm.$store.getters['user/isAuthenticated'];

                if(Object.keys(to.query).length !== 0) {
                    // In case we are already logged in, and we are in a redirect login page, just redirect.
                    if(to.query.redirect && isLoggedIn) {
                        next({
                            path: to.query.redirect
                        });
                    } else if(to.query.code) {
                        vm.$api.verifyRegistration(to.query.email, to.query.code).then(() => {
                            vm.$store.commit('user/verify', true);

                            if(isLoggedIn) {
                                next({path: '/'});
                            } else {
                                next();
                            }
                        });
                    }
                } else {
                    next();
                }
            });
        },

        methods: {
            async onLogin() {
                let that = this;

                this.isLoading = true;

                try {
                    let response = await this.$store.dispatch('user/login', {
                        username: this.username,
                        password: this.password
                    });

                    if(that.$route.query.redirect) {
                        that.$router.push(that.$route.query.redirect);
                    } else {
                        that.$router.push({name: 'Home'});
                    }
                }
                catch(err) {
                    this.isLoading = false;
                    this.error = true;
                    this.errorType = err.type;

                    this.password = '';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>